// removed by extract-text-webpack-plugin
module.exports = {"not-found-view":"jEjDemkg","notFoundView":"jEjDemkg","copy":"_1ZKQfjip","home":"_2hNQ6DSA"};


//////////////////
// WEBPACK FOOTER
// ./src/views/NotFoundView/NotFoundView.pcss
// module id = 1014
// module chunks = 0